export const items = [
  { id: "cafe", name: "Cafe de la machine", emoji: "\u2615", type: "heal", value: 15, desc: "Gout douteux, efficacite prouvee", maxStack: 3 },
  { id: "photocopie", name: "Photocopie certifiee conforme", emoji: "\ud83d\udcc4", type: "buff_atk", value: 5, duration: 3, desc: "+5 ATK pendant 3 tours", maxStack: 2 },
  { id: "ticket", name: "Ticket de file d'attente", emoji: "\ud83c\udfab", type: "buff_def", value: 8, duration: 3, desc: "+8 DEF pendant 3 tours", maxStack: 2 },
  { id: "justificatif", name: "Justificatif de domicile", emoji: "\ud83c\udfe0", type: "heal", value: 25, desc: "La preuve que tu existes", maxStack: 2 },
  { id: "rib", name: "RIB annote au crayon", emoji: "\ud83c\udfe6", type: "buff_luck", value: 10, duration: 3, desc: "+10 LUCK pendant 3 tours", maxStack: 1 },
  { id: "attestation", name: "Attestation sur l'honneur", emoji: "\u270b", type: "revive", value: 30, desc: "Reviens avec 30 HP -- Jure que c'est vrai", maxStack: 1 }
];

export const startingItems = {
  mere_isolee: ["cafe", "cafe", "justificatif"],
  etudiant: ["cafe", "ticket"],
  retraite: ["photocopie", "justificatif", "rib"],
  auto_entrepreneur: ["cafe", "attestation"],
  rsa_philosophe: ["cafe", "cafe", "cafe"]
};
